import React from 'react';
import LocationTemplate from './LocationTemplate';

const AlertPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Alert"
      stateName="North Carolina"
      countyName="Franklin"
      zipCodes={["27501"]} 
      latitude={36.2396}
      longitude={-77.925}
      population={null}
      historicalFact="Tiny rural community in Franklin County."
      nearbyTowns={[
        "Louisburg, NC",
        "Henderson, NC",
        "Franklinton, NC",
        "Bunn, NC",
        "Youngsville, NC",
        "Oxford, NC",
        "Warrenton, NC",
        "Norlina, NC"
      ]}
    />
  );
};

export default AlertPage;